module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-secondary-hover-bg-right.d04077c7.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-secondary-hover-bg-right.png
// module id = 3608
// module chunks = 11